import { FormModel_promotionCombos_FE } from '../../store/actionsV2-FormStateModel';

export interface PromotionCombo {
  block: PromotionBlock[];
  staggered: boolean;
  value?: number;
  id: number;
  order?: number;
  childrenCombos?: StaggeredChildrenCombos[];
}

export interface PromotionComboDTO {
  block: PromotionBlock[];
  isStaggered: boolean;
  value: number;
  id: number;
  childrenCombos?: StaggeredChildrenCombos[];
  order?: number;
  messageCommunicationType?: MessageCommunicationType;
}
export interface PromotionBlock {
  blockId?: string;
  items: number[];
  stock: number;
  name: string;
  id?: number;
  messageCommunicationType?: MessageCommunicationType;
  order?: number;
}

export interface StaggeredChildrenCombos {
  comboId: number;
  parentId: number; // id del promotion combo con index 0
  childrenBlocks: ChildrenBlocks[];
  value: number;
  order?: number;
  messageCommunicationType?: MessageCommunicationType;
}

export interface ChildrenBlocks {
  blockId: string | number;
  stock: number;
  messageCommunicationType?: MessageCommunicationType;
  order?: number;
}
export interface ComboEditModalData {
  title: string;
  payload: FormModel_promotionCombos_FE;
  action?: ComboListActions;
  isStaggeredNotFirst?: boolean;
  comboIndex?: number;
  isStaggered?: boolean;
}
export interface ComboEditModalDataV2 {
  title: string;
  payload: PromotionCombo;
  action?: ComboListActions;
  comboIndex?: number;
  isStaggered: boolean;
}
export enum ComboListActions {
  clone = 'clone',
  edit = 'edit',
  new = 'new',
  delete = 'delete',
  editValue = 'editValue',
}

export class StaggeredCombo {
  comboId: string | number;
  parentId: string | number;
  childrenBlocks: ChildrenBlocks[];

  constructor(comboId: string | number, parentId: string | number, childrenBlocks: ChildrenBlocks[]) {
    this.comboId = comboId;
    this.parentId = parentId;
    this.childrenBlocks = childrenBlocks;
  }
}
export class StaggeredBlock {
  blockId: string | number;
  stock: number;
  name: string;

  constructor(blockId: string | number, stock: number, name: string) {
    this.blockId = blockId;
    this.stock = stock;
    this.name = name;
  }
}

export enum MessageCommunicationType {
  itemNames = 'ItemNames',
  blockName = 'BlockName',
}
